import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { toast } from "sonner";

const NotificationsPage = () => {
  const [notifications, setNotifications] = useState([]);
  const navigate = useNavigate();

  const formatTime = (iso) => {
    if (!iso) return "";
    const created = new Date(iso);
    if (Number.isNaN(created.getTime())) return "";
    const diff = Date.now() - created.getTime();
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(diff / 3600000);
    if (minutes < 1) return "Just now";
    if (minutes < 60) return `${minutes}m ago`;
    if (hours < 24) return `${hours}h ago`;
    return new Intl.DateTimeFormat("en-US", { day: "numeric", month: "long" }).format(created);
  };

  const fetchNotifications = async () => {
    try {
      const response = await api.get("/notifications");
      setNotifications(response.data);
      await api.post("/notifications/read");
    } catch (error) {
      toast.error("Unable to load notifications.");
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  return (
    <div className="space-y-6" data-testid="notifications-page">
      <div>
        <h2 className="text-2xl font-semibold" data-testid="notifications-title">
          Notifications
        </h2>
        <p className="text-sm text-muted-foreground" data-testid="notifications-subtitle">
          Updates from your polls and follows.
        </p>
      </div>
      <div className="space-y-3" data-testid="notifications-list">
        {notifications.length === 0 ? (
          <div className="rounded-xl border border-border bg-card p-6 text-sm text-muted-foreground" data-testid="notifications-empty">
            No notifications yet.
          </div>
        ) : (
          notifications.map((notification) => (
            <button
              key={notification.id}
              className="w-full text-left rounded-xl border border-border bg-card p-4 hover:bg-accent"
              onClick={() => navigate(notification.link_url)}
              data-testid={`notification-item-${notification.id}`}
            >
              <div className="flex items-center gap-3">
                {notification.actor_avatar && (
                  <div
                    role="button"
                    tabIndex={0}
                    onClick={(event) => {
                      event.stopPropagation();
                      navigate(`/user/${notification.actor_username}`);
                    }}
                    onKeyDown={(event) => {
                      if (event.key === "Enter" || event.key === " ") {
                        event.stopPropagation();
                        navigate(`/user/${notification.actor_username}`);
                      }
                    }}
                    data-testid={`notification-user-link-${notification.id}`}
                  >
                    <img
                      src={notification.actor_avatar}
                      alt={notification.actor_username}
                      className="h-10 w-10 rounded-full object-cover"
                      data-testid={`notification-avatar-${notification.id}`}
                    />
                  </div>
                )}
                <div>
                  <div className="text-sm font-medium" data-testid={`notification-message-${notification.id}`}>
                    {notification.message}
                  </div>
                  <div className="text-xs text-muted-foreground" data-testid={`notification-time-${notification.id}`}>
                    {formatTime(notification.created_at)}
                  </div>
                </div>
              </div>
            </button>
          ))
        )}
      </div>
    </div>
  );
};

export default NotificationsPage;
